// extracted by mini-css-extract-plugin
module.exports = {"power-independence-G":"G_power-independence-G__moS3g"};